import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

/*
 * GoodUnited / Card. Figma: 10 / Components / Card.
 * Raised surface, 12px corners, default border, 24px padding and 16px gap.
 * Title is Poppins / text-xl / semibold, description Roboto / text-sm in Colors/text/secondary.
 */
function Card({ className, ...props }: ComponentProps<'div'>) {
    return (
        <div
            data-slot='card'
            className={cn('flex flex-col gap-4 rounded-xl border border-border-default bg-surface-raised p-6 text-text-primary', className)}
            {...props}
        />
    )
}

function CardHeader({ className, ...props }: ComponentProps<'div'>) {
    return (
        <div
            data-slot='card-header'
            className={cn('flex flex-col gap-1', className)}
            {...props}
        />
    )
}

function CardTitle({ className, ...props }: ComponentProps<'h3'>) {
    return (
        <h3
            data-slot='card-title'
            className={cn('flex items-center gap-2 font-heading text-xl font-semibold text-text-primary [&_svg]:size-5 [&_svg]:shrink-0 [&_svg]:text-icon-secondary', className)}
            {...props}
        />
    )
}

function CardDescription({ className, ...props }: ComponentProps<'p'>) {
    return (
        <p
            data-slot='card-description'
            className={cn('text-sm text-text-secondary', className)}
            {...props}
        />
    )
}

function CardAction({ className, ...props }: ComponentProps<'div'>) {
    return (
        <div
            data-slot='card-action'
            className={cn('ml-auto flex shrink-0 items-center gap-2', className)}
            {...props}
        />
    )
}

function CardContent({ className, ...props }: ComponentProps<'div'>) {
    return (
        <div
            data-slot='card-content'
            className={cn('flex flex-col gap-4', className)}
            {...props}
        />
    )
}

function CardFooter({ className, ...props }: ComponentProps<'div'>) {
    return (
        <div
            data-slot='card-footer'
            className={cn('flex items-center justify-between gap-4', className)}
            {...props}
        />
    )
}

export {
    Card,
    CardAction,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle
}
